<template>
  <div class="browse-product">
    <Product v-bind="$props" :lazy="lazy" @click="click" @changeProduct="onProductChange">
      <template v-if="canAddCart" v-slot:fixedCartCutton>
        <AddToCartButton :products="productParsed" :button-classes="['secondary']" :show-loader="true" @added="onAddToCart" />
      </template>
    </Product>
  </div>
</template>

<script>
import { MediaUtils } from '@/pixel/index';

import Product from '@/components/commons/ProductNA.vue';
import { trackEvent } from '../commons/utils.js';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'BrowseProduct',
  components: {
    Product,
    AddToCartButton: defineAsyncComponent(() => import('@/components/commons/AddToCartButton.vue')),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    badge: {
      type: Boolean,
      default: true,
    },
    showVariations: {
      type: Boolean,
      default: true,
    },
    spaceBottom: {
      type: Boolean,
      default: true,
    },
    canAddCart: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedProduct: {
        ...this.product,
      },
      isTabletAndSmaller: MediaUtils.isTabletAndSmaller,
    };
  },
  computed: {
    productParsed() {
      return [{ id: this.selectedProduct.hashKey, quantity: this.selectedProduct.packagedItemQuantity ?? 1 }];
    },
  },
  methods: {
    onProductChange(product) {
      this.selectedProduct = { ...product };
    },

    click() {
      this.$emit('click');
    },

    onAddToCart() {
      trackEvent('Products', 'Add To Cart', this.selectedProduct.skuNo, this.selectedProduct.priceNoCurrency);
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.browse-product {
  position: relative;

  .product-container {
    .product-link {
      margin: 0;
    }
  }

  &.hover {
    @media (min-width: $tablet-breakpoint) {
      .favorite {
        opacity: 0;
        transition: opacity 150ms ease-out, transform 200ms ease-out;
      }

      /* purgecss ignore */
      &:hover {
        .favorite {
          opacity: 1;
        }
      }
    }
  }
}
</style>
